import React from 'react';
import PropTypes from 'prop-types';
import { alpha, Box, Typography } from '@mui/material';
import { C, DETAIL_CARD_SX } from '../tokens';
import { getLocalizedText } from '../formatters';
import { SectionLabel } from '../atoms';

// Lists the bilingual `reasons[]` payload returned by the backend.
const DetailKeyReasonsCard = ({ detailDrawer, t, language }) => {
  const reasons = Array.isArray(detailDrawer?.reasons) ? detailDrawer.reasons : [];
  return (
    <Box sx={DETAIL_CARD_SX}>
      <Box sx={{
        px: 1.4,
        py: 1,
        bgcolor: alpha(C.blue, 0.035),
        borderBottom: `1px solid ${alpha(C.blue, 0.1)}`,
      }}>
        <SectionLabel>{t('breakoutCandidates.drawer.keyReasons')}</SectionLabel>
      </Box>
      <Box sx={{ px: 1.4, py: 1.15 }}>
        {reasons.length > 0 ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.8 }}>
            {reasons.map((reason, idx) => (
              <Box
                key={`${detailDrawer.ticker}-reason-${idx}`}
                sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.6 }}
              >
                <Box sx={{
                  width: 6,
                  height: 6,
                  borderRadius: '50%',
                  bgcolor: '#cbd5e1',
                  mt: 0.55,
                  flexShrink: 0,
                }} />
                <Typography sx={{ fontSize: '0.77rem', color: '#334155', lineHeight: 1.45, fontWeight: 500 }}>
                  {getLocalizedText(reason, language)}
                </Typography>
              </Box>
            ))}
          </Box>
        ) : (
          <Typography sx={{ fontSize: 12, color: C.mutedSoft }}>
            {t('breakoutCandidates.drawer.noReasons')}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

DetailKeyReasonsCard.propTypes = {
  detailDrawer: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  t: PropTypes.func.isRequired,
  language: PropTypes.string,
};

DetailKeyReasonsCard.defaultProps = {
  language: 'en',
};

export default DetailKeyReasonsCard;
